import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled, Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel/TabPanel";
import NativeFilter from "../NativeFilter/NativeFilter";
import NativeObject from "../NativeObject/NativeObject";

const LayoutWrapper = styled("div")({
  alignItems: "stretch",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

function FilterContainer({ app, config, index }) {
  const [activeTab, setActiveTab] = useState(index);

  const tabs = config.main;
  const handleSecondTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <LayoutWrapper>
      <div style={{ display: "flex", marginBottom: "24px" }}>
        <Tabs
          value={activeTab}
          onChange={handleSecondTabChange}
          style={{ width: "100%", display: "inline-block" }}
        >
          <Tab
            label={tabs[0].label}
            id={`tab-${1}`}
            aria-controls={`simple-tabpanel-${0}`}
          />
          <Tab
            label={tabs[1].label}
            id={`tab-${2}`}
            aria-controls={`simple-tabpanel-${1}`}
          />
          <Tab
            label={tabs[2].label}
            id={`tab-${3}`}
            aria-controls={`simple-tabpanel-${2}`}
          />
          <Tab
            label={tabs[3].label}
            id={`tab-${4}`}
            aria-controls={`simple-tabpanel-${3}`}
          />
          
        </Tabs>
      </div>
      <TabPanel
        value={activeTab}
        index={0}
        style={{ width: "100%", height: "100%" }}
      >
        <NativeObject
          app={app}
          reference={{ id: tabs[0].id }}
          style={{ width: "100%", height: "100%" }}
          type="table"
        />
      </TabPanel>
      <TabPanel
        value={activeTab}
        index={1}
        style={{ width: "100%", height: "100%" }}
      >
        <NativeObject
          app={app}
          reference={{ id: tabs[1].id }}
          style={{ width: "100%", height: "100%" }}
          type="table"
        />
      </TabPanel>
      <TabPanel
        value={activeTab}
        index={2}
        style={{ width: "100%", height: "100%" }}
      >
        <NativeObject
          app={app}
          reference={{ id: tabs[2].id }}
          style={{ width: "100%", height: "100%" }}
          type="table"
        />
      </TabPanel>
      <TabPanel
        value={activeTab}
        index={3}
        style={{ width: "100%", height: "100%" }}
      >
        <NativeObject
          app={app}
          reference={{ id: tabs[3].id }}
          style={{ width: "100%", height: "100%" }}
          type="table"
        />
      </TabPanel>
     
    </LayoutWrapper>
  );
}

export default FilterContainer;

FilterContainer.defaultProps = {
  app: null,
  config: {},
  index: 0,
};

FilterContainer.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  index: PropTypes.number,
};
